import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import initBootstrapComponents from '../../utils/bootstrap';
import '@splidejs/react-splide/css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

// Import images
import redWhiteCross from '../../assets/img/icons/red-white-cross.svg';
import alfaRomeoTonale from '../../assets/img/content/alfa-romeo-tonale.png';
import kiaNiro from '../../assets/img/content/kia-niro.png';
import fordPuma from '../../assets/img/content/ford-puma.png';

const CustomerBookings = () => {
    const [showRemoveModal, setShowRemoveModal] = useState(false);
    const [selectedBooking, setSelectedBooking] = useState(null);
    const [bookings, setBookings] = useState([
        {
            id: 1,
            eventName: 'Motability Scheme Live Harrogate 2025',
            date: 'November 29, 2024',
            time: '11:30am',
            participantName: 'Ellie Webber',
            vehicleName: 'Alfa Romeo Tonale',
            vehicleImage: alfaRomeoTonale
        },
        {
            id: 2,
            eventName: 'Motability Scheme Live Harrogate 2025',
            date: 'November 29, 2024',
            time: '2:30pm',
            participantName: 'Ellie Webber',
            vehicleName: 'Kia Niro',
            vehicleImage: kiaNiro
        },
        {
            id: 3,
            eventName: 'Motability Scheme Live Harrogate 2025',
            date: 'November 30, 2024',
            time: '4:30pm',
            participantName: 'Ellie Webber',
            vehicleName: 'Ford Puma',
            vehicleImage: fordPuma
        }
    ]);

    const [userDetails] = useState({
        name: 'Ellie Webber',
        telephone: '+44 7659 898 889',
        email: 'e.webber@mail.com'
    });

    useEffect(() => {
        // Initialize Bootstrap components when component mounts
        initBootstrapComponents();
    }, []);

    const handleRemoveBooking = (booking) => {
        setSelectedBooking(booking);
        setShowRemoveModal(true);
    };

    const confirmRemoveBooking = () => {
        if (selectedBooking) {
            setBookings(bookings.filter(booking => booking.id !== selectedBooking.id));
            setShowRemoveModal(false);
            setSelectedBooking(null);
        }
    };

    return (
        <div className="d-flex flex-column justify-content-between min-vh-100" id="body-container">
            <Header />

            <main>
                <section className="bg-motability-mid-black-5 py-32 pt-lg-96 pb-lg-411" id="book-a-test-drive-booking-confirmation">
                    <div className="container">
                        <h1 className="text-primary mb-4 mb-lg-5">
                            My bookings
                        </h1>

                        <div className="row gx-xxl-5 row-gap-4 row-gap-lg-0">
                            <div className="col-lg-6">
                                <div className="bg-motability-white border border-motability-mid-black-25 rounded-4 p-4 p-lg-32">
                                    <h4 className="text-primary mb-4">
                                        My bookings
                                    </h4>

                                    <div className="order-items">
                                        {bookings.map((booking) => (
                                            <div key={booking.id} className="order-item py-3 d-flex align-items-center gap-3">
                                                <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-3 flex-1">
                                                    <div className="d-flex align-items-center justify-content-center bg-motability-lighter-blue p-3 rounded-3">
                                                        <img
                                                            src={booking.vehicleImage}
                                                            alt={booking.vehicleName}
                                                            className="img-fluid w-124"
                                                            loading="lazy"
                                                        />
                                                    </div>

                                                    <div className="d-flex flex-column">
                                                        <p className="fw-semibold mb-0">
                                                            {booking.eventName}
                                                        </p>
                                                        <p className="mb-0">
                                                            <span className="fw-semibold">Booked From:</span> {booking.date} at {booking.time}
                                                        </p>
                                                        <p className="mb-0">
                                                            <span className="fw-semibold">Participant Name:</span> {booking.participantName}
                                                        </p>
                                                        <p className="fw-semibold mb-0">
                                                            {booking.vehicleName}
                                                        </p>
                                                    </div>
                                                </div>

                                                <button 
                                                    type="button" 
                                                    className="btn p-0"
                                                    onClick={() => handleRemoveBooking(booking)}
                                                >
                                                    <img
                                                        src={redWhiteCross}
                                                        alt="Remove booking"
                                                        className="img-fluid"
                                                        width="24"
                                                        height="24"
                                                        loading="lazy"
                                                    />
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="bg-motability-mid-black-5 border border-motability-mid-black-2 rounded-4 p-4 p-lg-32">
                                    <div className="d-flex align-items-center justify-content-between gap-4 mb-4 mb-lg-32">
                                        <h4 className="text-primary mb-0">
                                            My details
                                        </h4>

                                        <Link to="/edit-details" className="fw-medium">
                                            Edit details
                                        </Link>
                                    </div>

                                    <p className="fw-semibold mb-2">
                                        {userDetails.name}
                                    </p>

                                    <p className="mb-2">
                                        {userDetails.telephone}
                                    </p>

                                    <p className="mb-0">
                                        {userDetails.email}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            <Footer />

            <Modal
                show={showRemoveModal}
                onHide={() => setShowRemoveModal(false)}
                centered
                aria-labelledby="remove-booking-modal"
            >
                <Modal.Header className="pt-64 pb-39 border-0 justify-content-center">
                    <h4 className="text-primary text-center mb-0" id="remove-booking-modal">
                        Are you sure you want to remove your booking?
                    </h4>
                </Modal.Header>

                <Modal.Footer className="gap-2 gap-lg-64 px-3 pt-0 pb-64 justify-content-center border-0">
                    <button 
                        type="button" 
                        className="btn btn-outline-primary fw-normal m-0 px-lg-64"
                        onClick={() => setShowRemoveModal(false)}
                    >
                        Cancel
                    </button>

                    <button 
                        type="button" 
                        className="btn btn-primary m-0 px-lg-29"
                        onClick={confirmRemoveBooking}
                    >
                        Remove my booking
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default CustomerBookings;
